import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { connect, useDispatch } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Modal from "./containers/Modal";
import { ScrollToTop } from "./containers/ScrollToTop";
import Toasts from "./containers/Toasts";
import LoadingScreen from "./pages/LoadingScreen";
import DefaultLayout from "./pages/layouts/DefaultLayout";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5000,
    },
  },
});

function App({ modal }) {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => setLoading(false), 2000);
  }, [dispatch]);

  return (
    <>
      {!loading ? (
        <>
          <QueryClientProvider client={queryClient}>
            <Toasts />
            <ToastContainer position="top-right" />
            <BrowserRouter>
              <ScrollToTop>
                <DefaultLayout />
              </ScrollToTop>
            </BrowserRouter>

            {modal.modalType && <Modal modal={modal} />}
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};

export default connect(mapStateToProps)(App);
